// Dependency
import React from 'react';
import { Link } from "gatsby";
import Img from "gatsby-image";

// Components


// Internationalization
import { useTranslation } from 'react-i18next';

// Styles
import * as styles from './mega-nav.module.scss';

// Template
const SmallNav = (props) => {

    // Translation Function
    const { t } = useTranslation();

    return (
        <div className={` ${styles.cdSmallNav} ${props.isOpen ? styles.isOpen : ''}`}>
            <div className="cd-max-width">
                <div className={styles.cdSmallNavContent}>
                    {props.pages.map((page, index) => {
                        let linkName = page._allNameLocales.filter( (linkNameLocale) => {
                            return linkNameLocale.locale === props.locale.lang;
                        } );

                        let linkUrl = page._allUrlLocales.filter( (linkURLLocale) => {
                            return linkURLLocale.locale === props.locale.lang;
                        } );

                        return (
                            <Link key={index} to={`/${props.locale.country}${linkUrl[0].value}/`} className={`${styles.cdSmallNavItem} cd-background-img`}>
                                <Img fluid={page.thumbnail.fluid} alt="" />
                                <div className="cd-background-overlay"></div>
                                <h4>{linkName[0].value}</h4>
                            </Link>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

export default SmallNav;